import React from 'react';
import {makeStyles, withStyles, Grid, Divider} from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';
import Title from './Title';
import CustomProgressBar from "./CustomProgressBar";
import {FormattedMessage} from 'react-intl';
import moment from 'moment';

const useStyles = makeStyles((theme) => ({
    depositContext: {
        flex: 1,
    },
    container: {
        paddingTop: theme.spacing(3),
        paddingBottom: theme.spacing(1),
    },
    circularProgress: {
        display: 'flex',
        justifyContent: 'center',
        marginTop: theme.spacing(1),
    },
    remark: {
        marginTop: 15,
    },
}));

const StyledDivider = withStyles((theme) => ({
    root: {
        marginBottom: theme.spacing(2),
        background: '#DCDCDC',
        height: 2,
    },
}))(Divider);

export default function Balance({mode, userRole = '', annualAllowances, sickAllowances, compLeaveAllowances}) {
    const classes = useStyles();
    const [showCompetent, setShowCompetent] = React.useState(false);
    const [showSickCompetent, setShowSickCompetent] = React.useState(false);
    const isOfficeHourDuty = localStorage.getItem('staff_duty') === window.global.officeHours;
    const isHomeMode = mode === window.global.homeMode;
    const strokeColor = ['orange', 'green', 'blue', 'purple', 'brown'];
    const fourMonthsAgo = moment().subtract(4, 'months').add(1, 'days').format('YYYY/MM/DD');
    const threeMonthsAgo = moment().subtract(3, 'months').format('YYYY/MM/DD');
    const noCompLeaveRecords = compLeaveAllowances?.total == 0 && compLeaveAllowances?.taken == 0 && compLeaveAllowances?.balance == 0;

    React.useEffect(() => {
        if (annualAllowances) {
            setShowCompetent(true);
        }

        if (userRole === window.global.hrAdmin) {
            setShowSickCompetent(true);
        }
    }, [annualAllowances]);

    return (
        <React.Fragment>
            {showCompetent ?
                <div>
                    {isOfficeHourDuty && isHomeMode ? (
                        <Grid container spacing={3}>
                            <Grid item xs={12} md={7}>
                                <Title>
                                    <FormattedMessage
                                        id="balance.title"
                                    />
                                </Title>
                                <StyledDivider/>
                                <Grid container spacing={3}>
                                    {annualAllowances.map(function (annualAllowance, i) {
                                        return <React.Fragment key={i}>
                                            <CustomProgressBar
                                                mode={mode}
                                                taken={annualAllowance.taken}
                                                total={annualAllowance.total}
                                                balance={annualAllowance.balance}
                                                year={annualAllowance.year}
                                                strokeColor={strokeColor[i]}
                                                md={isHomeMode ? 3 : ''}
                                            />
                                        </React.Fragment>
                                    })}
                                </Grid>
                            </Grid>
                            <Grid item xs={12} md={5}>
                                <Title>
                                    <FormattedMessage
                                        id="comp_leave_balance.title"
                                    />
                                </Title>
                                <StyledDivider/>
                                <Grid container spacing={3}>
                                    <>
                                        <CustomProgressBar
                                            mode={mode}
                                            total={compLeaveAllowances?.total}
                                            taken={compLeaveAllowances?.taken}
                                            balance={compLeaveAllowances?.balance}
                                            toBeExpiredBalance={compLeaveAllowances?.toBeExpiredBalance}
                                            title='comp_leave_balance.active'
                                            hours='balance.hours'
                                            md={isHomeMode ? 5 : ''}
                                            strokeColor={noCompLeaveRecords ? '#E6E6E6' : 'brown'}
                                        />
                                    </>
                                </Grid>
                                {compLeaveAllowances.recentExpiredBalance > 0 && 
                                    <div className={classes.remark}>
                                        <FormattedMessage 
                                            id="comp_leave_balance.remark_expired"
                                            values={{ 
                                                    hours: (compLeaveAllowances.recentExpiredBalance).toFixed(1),
                                                    from: fourMonthsAgo,
                                                    to: threeMonthsAgo,
                                            }} 
                                        />
                                    </div>
                                }
                            </Grid>
                        </Grid>
                    ) : (
                        <>
                            <Title>
                                <FormattedMessage
                                    id="balance.title"
                                />
                            </Title>
                            <StyledDivider/>
                            <Grid container spacing={3}>
                                {annualAllowances.map(function (annualAllowance, i) {
                                    return <React.Fragment key={i}>
                                        <CustomProgressBar
                                            mode={mode}
                                            taken={annualAllowance.taken}
                                            total={annualAllowance.total}
                                            balance={annualAllowance.balance}
                                            year={annualAllowance.year}
                                            strokeColor={strokeColor[i]}
                                        />
                                    </React.Fragment>
                                })}
                            </Grid>
                        </>
                    )}
                    {showSickCompetent && (
                        <>
                            <Title>
                                <FormattedMessage id="sick_balance.title" />
                            </Title>
                            <StyledDivider />
                            <Grid container spacing={3}>
                                <CustomProgressBar
                                    key="sickAllowance"
                                    mode={mode}
                                    taken={sickAllowances.taken}
                                    total={sickAllowances.total}
                                    balance={sickAllowances.balance}
                                    strokeColor={'cyan'}
                                    balanceTotal={'new_application.entitled'}
                                />
                            </Grid>
                        </>
                    )}
                </div>
                :
                <div className={classes.circularProgress}>
                    <CircularProgress/>
                </div>
            }
        </React.Fragment>
    );
}
